// extracted by mini-css-extract-plugin
export default {"root":"Messages_root__03mdq"};